var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProfileActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 32,
    viewBox: "0 0 25 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.594%",
    y1: "100%",
    x2: "4.406%",
    y2: "0%",
    id: "gwbbb2blea"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "71.054%",
    x2: "0%",
    y2: "28.946%",
    id: "5xcsfqbibb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95FFF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.31 15.116c1.984 0 3.701-.745 5.104-2.214 1.403-1.47 2.114-3.267 2.114-5.344 0-2.076-.71-3.874-2.114-5.344C16.01.744 14.294 0 12.31 0c-1.983 0-3.7.745-5.103 2.214-1.403 1.47-2.114 3.267-2.114 5.344 0 2.077.711 3.875 2.114 5.344 1.403 1.47 3.12 2.214 5.103 2.214z",
    fill: "url(#gwbbb2blea)",
    transform: "translate(0 .594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.697 22.147c-.122-.71-.279-1.38-.466-1.993a10.09 10.09 0 0 0-.783-1.86 6.988 6.988 0 0 0-1.18-1.61 5.177 5.177 0 0 0-1.695-1.116 5.625 5.625 0 0 0-2.164-.41c-.306 0-.602.132-1.173.521-.352.24-.763.518-1.222.825-.392.262-.924.508-1.581.73a6.02 6.02 0 0 1-1.934.327c-.642 0-1.292-.11-1.934-.327-.656-.222-1.188-.468-1.58-.73-.454-.304-.866-.582-1.223-.825-.57-.39-.867-.521-1.172-.521-.78 0-1.507.138-2.164.41a5.172 5.172 0 0 0-1.696 1.116 6.99 6.99 0 0 0-1.18 1.61 10.11 10.11 0 0 0-.782 1.86 16.275 16.275 0 0 0-.465 1.993c-.12.704-.203 1.37-.243 1.984-.04.6-.06 1.223-.06 1.853 0 1.638.497 2.964 1.478 3.942.968.965 2.25 1.455 3.808 1.455h14.428c1.558 0 2.84-.49 3.808-1.455.98-.977 1.478-2.304 1.478-3.942 0-.633-.02-1.256-.06-1.854a19.508 19.508 0 0 0-.243-1.983z",
    fill: "url(#5xcsfqbibb)",
    transform: "translate(0 .594)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileActive);
export default __webpack_public_path__ + "static/media/ic_profile_active.c43a84f2708c7426f912d1adc66b6f6f.svg";
export { ForwardRef as ReactComponent };